<div class="row bg-light no-gutters p-3">
  <div class="col-4 d-flex justify-content-center">
    <div>
      <div class="font14-600">{{certificate.oemCustomerId}}</div>
      <div class="font13-400 mt-1">{{certificate.name}}</div>
    </div>
  </div>
  <div class="col-4"></div>
  <div class="col-4 text-center">
    <div class="font13-400">Vehicles</div>
    <div class="font14-600 mt-1">{{certificate.vehicles}}</div>
  </div>
</div>